import { createAction } from '@reduxjs/toolkit';

import type { Cart } from 'domains/cart/cart.types';
import type { CartOrderOption } from './cart_order_options.types';

export const getCartOrderOptions = {
  fulfilled: createAction<CartOrderOption[]>('cartOrderOptions/getCartOrderOptions/fulfilled'),
  rejected: createAction('cartOrderOptions/getCartOrderOption/rejected'),
};

export const createCartOrderOption = {
  pending: createAction<number>('cartOrderOptions/createCartOrderOption/pending'),
  fulfilled: createAction<Cart>('cartOrderOptions/createCartOrderOption/fulfilled'),
  rejected: createAction('cartOrderOptions/createCartOrderOption/rejected'),
};

export const deleteCartOrderOption = {
  pending: createAction<number>('cartOrderOptions/deleteCartOrderOption/pending'),
  fulfilled: createAction<Cart>('cartOrderOptions/deleteCartOrderOption/fulfilled'),
  rejected: createAction('cartOrderOptions/deleteCartOrderOption/rejected'),
};
